import Script from 'next/script';
const GA = process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID;

export default function GoogleAnalytics() {
  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${GA}`} />

      <Script
        id='google-analytics'
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA}');
        `,
        }}
      />
    </>
  );
}
